import React from 'react'
import {Input} from 'antd'
import styles from './Search.module.scss'

const { Search } = Input


export const GenericSearch: React.FC<React.ComponentProps<typeof Search>> = ({
                                                                                 className,
                                                                                 style,
                                                                                 ...rest
                                                                             }) => {
    const wrapperClass = `${styles.container} ${styles.fixedTopRight}`
    const inputClass = `${styles.search}${className ? ` ${className}` : ''}`

    return (
        <div className={wrapperClass} style={style}>
            <Search className={inputClass} {...rest} />
        </div>
    )
}

